import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {Row,Col,Container} from 'react-bootstrap';
import { getPartnerData, isPartnerDomain } from '../../partnerDomain';

class Footer extends React.Component {

	render() {
		const partnerData = getPartnerData();
		const onPartnerDomain = isPartnerDomain() && partnerData;
		const siteName = onPartnerDomain ? partnerData.name : 'Liefershops';

    	return (
    		<>
			    <section className="footer pt-5 pb-5">
			         <Container>
			            <Row className="d-flex justify-content-between text-center">
							<Col md={3} sm={4} xs={6}>
								<ul>
			                     	<li><Link to="/Impressum">Impressum</Link></li>
								</ul>
							</Col>
							<Col md={3} sm={4} xs={6}>
								<ul>
			                     	<li><Link to="/Agb">AGB</Link></li>
								</ul>
							</Col>
							<Col md={3} sm={4} xs={6}>
								<ul>
			                     	<li><Link to="/Datenschutz">Datenschutz</Link></li>
								</ul>
							</Col>
							<Col md={3} sm={4} xs={6}>
								<ul>
			                     	<li><Link to="/Feedback">Feedback geben</Link></li>
								</ul>
							</Col>
			            </Row>
			         </Container>
			    </section>
		      <footer className="pt-4 pb-4 text-center">
		         <Container>
		            <p className="mt-0 mb-0">&copy; {new Date().getFullYear()} {siteName}</p>
		            {!onPartnerDomain && (
		            	<small className="mt-0 mb-0"> Websiteerstellung:
		            		<Link className="text-danger-oktalion ml-1" target="_blank" to="//oktalion.de/">Web- &amp; Grafikdesign "Oktalion"</Link>
		            	</small>
		            )}
		         </Container>
		      </footer>
		    </>
    	);
    }
}

export default Footer;
